/* unplugin-vue-components disabled */import { render } from "./PIAuthorize.vue?vue&type=template&id=34b5cf9c"
import script from "./PIAuthorize.vue?vue&type=script&lang=js"
export * from "./PIAuthorize.vue?vue&type=script&lang=js"

import "./PIAuthorize.vue?vue&type=style&index=0&id=34b5cf9c&less=true&lang=css"

import exportComponent from "D:\\星网代码\\2018-05-18 路特利\\2022-02-23需求\\DM.LtlApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__